module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-24.35edaf7b.png";